import { spotlightSplitWithMetrics } from "@redotech/redo-spotlight-common/spotlight-schema";
import * as z from "zod";

export const getSpotlightSplits = {
  name: "getSpotlightSplits" as const,
  input: z.object({}),
  output: z.array(spotlightSplitWithMetrics),
};
